import { buildEmailPalette, buildThemeVars, DEFAULT_PRIMARY } from "@propsys/shared";

let current = "";
let currentColors: [string | null | undefined, string | null | undefined] = [null, null];

/** A két márkaszínből számolt CSS változók felrakása a <html>-re. */
export function applyTheme(primary?: string | null, secondary?: string | null) {
  const key = `${primary ?? ""}|${secondary ?? ""}`;
  if (key === current) return;
  current = key;
  currentColors = [primary, secondary];
  const vars = buildThemeVars(primary, secondary);
  const root = document.documentElement;
  for (const [k, v] of Object.entries(vars)) root.style.setProperty(k, v);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", primary || DEFAULT_PRIMARY);
}

/** Az aktuális téma hex színei (konfetti, canvas, export). */
export function currentPalette() {
  return buildEmailPalette(currentColors[0], currentColors[1]);
}
